// import React from "react";
// import '../styles/user_management_styles.css';
// import Navbar from "./Navbar.js";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Table from "./Table.js";
// import useFetch from './useFetch.js';
// import config from '../config.js';
// import Cookie from 'universal-cookie';

// const Views = () => {
//     const cookies = new Cookie();
//     let actionInitiatingUser = -1;
//     try {
//         actionInitiatingUser = parseInt(cookies.get('userID'));
//     } catch (error) {}

//     const { data: views, isPending, error } = useFetch({
//         actionInitiatingUser: { userID: actionInitiatingUser },
//         URL: config.BACKEND_URL + '/views'
//     });

//     return (
//         <div className="Reports">
//             <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
//             <Navbar />
//             <main className="container-fluid">
//                 <section className="d-flex row justify-content-center" style={{ padding: "1vw" }}>
//                     <header className="h1 text-center">Views</header>
//                     <section className="col-sm-8">
//                         {isPending && <div className="text-center mt-5 h2">Loading...</div>}
//                         {error && <div className="text-center mt-5 h2">Failed to fetch data!</div>}
//                         {views && (
//                             views.length === 0 ? (
//                                 <div className="text-center mt-5 h2">Currently, there are no views!</div>
//                             ) : (
//                                 <Table
//                                     tableData={views.map(view => ({
//                                         id: view.id, // Include id for row selection
//                                         name: view.name,
//                                         start: new Date(view.timeStamps.start).toLocaleString('en-GB', { hour12: false }).substring(0, 20),
//                                         end: new Date(view.timeStamps.end).toLocaleString('en-GB', { hour12: false }).substring(0, 20),
//                                         sourceIDs: view.sourceIDs,
//                                         createdAt: view.createdAt
//                                     }))}
//                                     tableColumns={[
//                                         {
//                                             title: "Name",
//                                             field: "name"
//                                         },
//                                         {
//                                             title: "Start timestamp",
//                                             field: "start"
//                                         },
//                                         {
//                                             title: "End timestamp",
//                                             field: "end"
//                                         },
//                                         {
//                                             title: "Source IDs",
//                                             field: "sourceIDs",
//                                             formatter: (cell) => {
//                                                 const sourceIDs = cell.getValue();
//                                                 return Array.isArray(sourceIDs) ? sourceIDs.join(", ") : "N/A";
//                                             },
//                                             sorter: (a, b) => {
//                                                 // Convert arrays to strings for comparison
//                                                 const aStr = Array.isArray(a) ? a.join(",") : "";
//                                                 const bStr = Array.isArray(b) ? b.join(",") : "";
//                                                 return aStr.localeCompare(bStr);
//                                             }
//                                         },
//                                         {
//                                             title: "Created At",
//                                             field: "createdAt"
//                                         }
//                                     ]}
//                                     shouldModifySources={false}
//                                     isSelectable={false}
//                                     shouldDownload={true}
//                                     tableID={"views"}
//                                 />
//                             )
//                         )}
//                     </section>
//                 </section>
//             </main>
//         </div>
//     );
// };

// export default Views;

import React from "react";
import Navbar from "./Navbar.js";
import useFetch from "./useFetch.js";
import config from "../config.js";
import Cookie from "universal-cookie";
import Table from "./Table.js";
import {
  Box,
  Typography,
  Card,
  CircularProgress,
  Divider,
} from "@mui/material";
import { Layout, AlertCircle, Database } from "lucide-react";

const Views = () => {
  const cookies = new Cookie();
  let actionInitiatingUser = -1;
  try {
    actionInitiatingUser = parseInt(cookies.get("userID"));
  } catch (error) {}

  const {
    data: views,
    isPending,
    error,
  } = useFetch({
    actionInitiatingUser: { userID: actionInitiatingUser },
    URL: config.BACKEND_URL + "/views",
  });

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0f1729", pb: 6 }}>
      {/* Legacy Icon Support */}
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />

      <Navbar />

      <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: "1300px", mx: "auto", mt: 4 }}>
        {/* Header Section */}
        <Box sx={{ mb: 4, textAlign: { xs: "center", md: "left" } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", md: "flex-start" },
              gap: 1.5,
            }}
          >
            <Layout size={28} color="#60a5fa" />
            <Typography variant="h4" sx={{ fontWeight: 700, color: "white" }}>
              Views
            </Typography>
          </Box>
          <Typography
            sx={{ fontSize: "1.1rem", color: "rgba(255,255,255,0.7)", mt: 0.5 }}
          >
            Manage and monitor your configured data perspectives.
          </Typography>
        </Box>

        {/* Main Content Card */}
        <Card
          elevation={0}
          sx={{
            background: "rgba(15, 23, 42, 0.6)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            color: "white",
            borderRadius: "16px",
            border: "1px solid rgba(148, 163, 184, 0.15)",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
            p: { xs: 1, sm: 3 },
          }}
        >
          {isPending && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                py: 10,
              }}
            >
              <CircularProgress sx={{ color: "#3b82f6", mb: 2 }} />
              <Typography variant="h6" sx={{ color: "rgba(148,163,184,0.8)" }}>
                Loading views...
              </Typography>
            </Box>
          )}

          {error && (
            <Box sx={{ textAlign: "center", py: 10, color: "#ef4444" }}>
              <AlertCircle size={48} style={{ marginBottom: "16px" }} />
              <Typography variant="h6">Failed to fetch data!</Typography>
            </Box>
          )}

          {views &&
            (views.length === 0 ? (
              <Box sx={{ textAlign: "center", py: 10 }}>
                <Database
                  size={48}
                  color="#64748b"
                  style={{ marginBottom: "16px" }}
                />
                <Typography variant="h6" sx={{ color: "#94a3b8" }}>
                  Currently, there are no views!
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  // Custom styling for the internal Table container to ensure responsiveness
                  "& .tabulator": { borderRadius: "8px", overflow: "hidden" },
                  overflowX: "auto",
                }}
              >
                <Table
                  tableData={views.map((view) => ({
                    id: view.id,
                    name: view.name,
                    start: new Date(view.timeStamps.start)
                      .toLocaleString("en-GB", { hour12: false })
                      .substring(0, 20),
                    end: new Date(view.timeStamps.end)
                      .toLocaleString("en-GB", { hour12: false })
                      .substring(0, 20),
                    sourceIDs: view.sourceIDs,
                    createdAt: view.createdAt,
                  }))}
                  tableColumns={[
                    { title: "Name", field: "name" },
                    { title: "Start timestamp", field: "start" },
                    { title: "End timestamp", field: "end" },
                    {
                      title: "Source IDs",
                      field: "sourceIDs",
                      formatter: (cell) => {
                        const sourceIDs = cell.getValue();
                        return Array.isArray(sourceIDs)
                          ? sourceIDs.join(", ")
                          : "N/A";
                      },
                      sorter: (a, b) => {
                        const aStr = Array.isArray(a) ? a.join(",") : "";
                        const bStr = Array.isArray(b) ? b.join(",") : "";
                        return aStr.localeCompare(bStr);
                      },
                    },
                    { title: "Created At", field: "createdAt" },
                  ]}
                  shouldModifySources={false}
                  isSelectable={false}
                  shouldDownload={false}
                  tableID={"views"}
                />
              </Box>
            ))}
        </Card>
      </Box>
    </Box>
  );
};

export default Views;
